import {useState, useEffect} from 'react'
import './App.css';
import verified from './ver.png'
import page from './404.webp'

const Stat = ({label, figure}) => {
  return (
          <div className="main_stat_details">
              <p className='stat_details_label'>{label}</p>
              <p className='stat_detail_figure'>{figure}</p>
            </div>
  )
}

const App = ()=> {
  const [result, setresult] = useState(false);
  const [errorMessage, seterrorMessage] = useState(false)
  const [slug, setslug] = useState("");
  const [data, setdata] = useState();
  const [collections, setcollections] = useState();
  const [projectList, setprojectList] = useState([]);

  const url = `https://api.opensea.io/api/v1/collection/${slug}`


  const loadProjects = ()=> {
    const options = {method: 'GET', headers: {Accept: 'application/json'}};

  fetch('https://api.opensea.io/api/v1/collections?offset=300&limit=300', options)
    .then(response => response.json())
    .then((response) =>{
      console.log(response.collections)
      setprojectList(response.collections);
    })
    .catch(err => console.error(err));
  }
 

  const getStats =()=>{
    const options = {method: 'GET', headers: {Accept: 'application/json'}};

    fetch(url, options)
      .then(response => response.json())
      .then((response) => {
        console.log(response);
        if(response.success !== false){
          seterrorMessage(false)
          setresult(true)
          setcollections(response)
          setdata(response.collection.stats);
        }else{
          setresult(false);
          seterrorMessage(true)
        }
      })
      .catch((err) => {
        console.error(err);
      })
  }

  const onchange=(e)=> {
    const inputedSlug = e.target.value;
    const slug_to_use = inputedSlug.replace(/\s/g,"-");
    const finalSlug = slug_to_use.toLowerCase();
    setslug(finalSlug);
  }

 

  function kFormatter(num) {
    return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
}

const enterPress = e =>{
  if(e.keyCode === 13){
    getStats();

  }
}

useEffect(() => {
  loadProjects();
}, [])


  return (
    <main className="App">
      <h1>NFT Stat Finder</h1>
      <section className="searchpanel">
        <input type="text" onChange={onchange} onKeyDown={enterPress}
         list="projects" 
        placeholder="Type Project slug to Get Stats..." />
        <datalist id="projects" className='datalist
        
        '>
          {
            projectList.map((item, index) => (
                
              <option key={index} value={item.slug}/>
            ))
          }
          
        </datalist>
        <span onClick={getStats}  >Search</span>
      </section>
      <p className='guide'>E.g boredapeyachtclub, Azuki, Afrodroids by owo, doodles official, etc</p>

      {
        result &&

        <section className="stat">
          <div className="nft_image">
            <img src={collections.collection.image_url } alt="" />
          </div>
          <div className="heading">
           <h2 className="project_name">{collections.collection.name}</h2> 
           {collections.collection.safelist_request_status === "verified" && <p className='verification'><img src={verified} alt="" /></p>}
          </div>
          <section className='stat-body'>

         
          <div className="main_stat">
           <Stat label={"Items"} figure={kFormatter(data.count)}/>
           <Stat label={"Owners"} figure={kFormatter(data.num_owners)}/>
           <Stat label={"Floor"} figure={data.floor_price + ' ETH'}/>
           <Stat label={"Volume Traded"} figure={kFormatter(Math.round(data.total_volume))}/>
          </div>
          <div className="main_stat">
          <Stat label={"Average Price"} figure={kFormatter(data.average_price.toFixed(3))}/>
          <Stat label={"Total Supply"} figure={kFormatter(data.total_supply)}/>
          <Stat label={"Total Sales"} figure={data.total_sales}/>
          <Stat label={"Market Cap"} figure={kFormatter(data.market_cap.toFixed(2))}/>
          </div>
          </section>

          <h3>Market Distribution</h3>
         
            <section className="stat-body">
              <div className="main_stat">
              <Stat label={"1 Day Average Price"} figure={kFormatter(data.one_day_average_price.toFixed(3))}/>
              <Stat label={"1 Day Change"} figure={kFormatter(data.one_day_change.toFixed(3))}/>
              <Stat label={"1 Day Sales"} figure={data.one_day_sales}/>
              <Stat label={"1 Day Volume"} figure={data.one_day_volume.toFixed(3)}/>
              </div>
              <div className="main_stat">
              <Stat label={"7 Days Volume"} figure={kFormatter(data.seven_day_average_price.toFixed(3))}/>
              <Stat label={"7 Days Change"} figure={kFormatter(data.seven_day_change.toFixed(3))}/>
              <Stat label={"7 Days Sales"} figure={data.seven_day_sales}/>
              <Stat label={"7 Days Volume"} figure={data.seven_day_volume.toFixed(3)}/>
              </div>
              <div className="main_stat">
              <Stat label={"30 Days Volume"} figure={kFormatter(data.thirty_day_average_price.toFixed(3))}/>
              <Stat label={"30 Days Change"} figure={kFormatter(data.thirty_day_change.toFixed(3))}/>
              <Stat label={"30 Days Sales"} figure={data.thirty_day_sales}/>
              <Stat label={"30 Days Volume"} figure={data.thirty_day_volume.toFixed(3)}/>
              
              </div>
           
            </section>
          
        </section>
      }
      {
        errorMessage && 
          <section className='errBound'>
            <div className='errImg'>
              <img src={page} alt="error" />
            </div>
            <p className='err'> We could not find the Collection. <br/> 
            Believe me, we are still looking for it but make sure 
            you are providing the correct slug of the collection and try again.</p>

          </section>
        
      }
    </main>
  );
}

export default App;
